<template>
  <li class="flex items-center space-x-2 px-2">
    <div class="flex items-center justify-center rounded-sm border p-2">
      <img
        v-if="serviceAttributeImg"
        :src="serviceAttributeImg"
        class="h-5 w-5 min-w-5"
        :alt="option.label || option.name"
        loading="lazy"
      />
    </div>
    <div class="space-y-1 text-gray-500">
      <highlight-text :content="optionName" :needle="needle" />
      <div v-if="option.label" class="text-gray-400">
        <highlight-text :content="option.label" :needle="needle" />
      </div>
    </div>
  </li>
</template>
<script setup lang="ts">
import { computed } from "vue";

import { EditorNodeName } from "@/enums/customAttributes";
import {
  SERVICE_APPLICATION_DATA,
  SERVICE_CUSTOM_ATTRIBUTES,
} from "@/helpers/constants";
import { getImageForService } from "@/helpers/services";
import { useAttributeBuilderServices } from "@/hooks/attributeBuilder";

import HighlightText from "@/components/HighlightText.vue";

import type { CustomAttributeDropdownOption } from "@/models/customAttributes/searchSelectDropdown";

const props = defineProps<{
  option: CustomAttributeDropdownOption;
  needle: string;
}>();

const { getServiceProviderDetails } = useAttributeBuilderServices();

const serviceAttributeProviderInfo = computed(() =>
  getServiceProviderDetails(props.option.id)
);

const serviceAttributeImg = computed(() => {
  if (
    props.option.type === EditorNodeName.function ||
    props.option.type === EditorNodeName.attributeOption
  ) {
    return getImageForService(props.option.type);
  } else if (
    serviceAttributeProviderInfo.value?.category &&
    (
      [SERVICE_APPLICATION_DATA, SERVICE_CUSTOM_ATTRIBUTES] as string[]
    ).includes(serviceAttributeProviderInfo.value?.category)
  ) {
    return getImageForService(serviceAttributeProviderInfo.value?.category);
  } else {
    return getImageForService(serviceAttributeProviderInfo.value?.id);
  }
});

const optionName = computed(() => {
  const suffix = props.option.aliases?.length
    ? `aliases: (${props.option.aliases.join(", ")})`
    : "";
  return `${props.option.name} ${suffix}`;
});
</script>
